/* DDS global product Quick View v1: uses inert per-card product data.
   Event delegation means it also supports asynchronously inserted product cards.
   Separate from the New Arrivals dialog and the old Warehouse loader.
*/
(function(){
'use strict';
if(window.__ddsGlobalQuickViewBooted) return;
window.__ddsGlobalQuickViewBooted = true;
function boot(){
var dialog=document.querySelector('[data-dds-global-qv]');
if(!dialog) return;
var panel=dialog.querySelector('[data-dds-global-qv-panel]');
var content=dialog.querySelector('[data-dds-global-qv-content]');
var closer=dialog.querySelector('[data-dds-global-qv-close]');
if(!panel||!content||!closer) return;
var lastFocus=null,lastOverflow='',open=false,submitting=false;
function close(){
if(!open||submitting) return;
open=false;dialog.hidden=true;content.replaceChildren();document.body.style.overflow=lastOverflow;
if(lastFocus&&lastFocus.isConnected)lastFocus.focus();
}
function openCard(button){
var card=button.closest('.product-item');
var source=card&&card.querySelector('[data-dds-global-qv-template]');
if(!source||!source.content) return;
content.replaceChildren(source.content.cloneNode(true));
lastFocus=button;lastOverflow=document.body.style.overflow;dialog.hidden=false;open=true;
document.body.style.overflow='hidden';
closer.focus();
var variant=content.querySelector('[data-dds-global-qv-variant]');
var price=content.querySelector('[data-dds-global-qv-price]');
var availability=content.querySelector('[data-dds-global-qv-availability]');
var add=content.querySelector('[data-dds-global-qv-add]');
var status=content.querySelector('[data-dds-global-qv-status]');
var cartLink=content.querySelector('[data-dds-global-qv-cart]');
function update(){
if(!variant) return;
var option=variant.options[variant.selectedIndex];
if(!option) return;
var available=option.dataset.available==='true';
if(price)price.textContent=option.dataset.price||'';
if(availability)availability.textContent=available?'Available':'Sold out';
if(add)add.disabled=!available;
if(status)status.textContent='';
if(cartLink)cartLink.hidden=true;
}
if(variant){variant.addEventListener('change',update);update();}
var form=content.querySelector('.dds-global-qv__form');
if(form){
form.addEventListener('submit',async function(event){
event.preventDefault();event.stopPropagation();
if(submitting)return;
if(!variant||!variant.value||add?.disabled)return;
submitting=true;
if(add){add.disabled=true;add.textContent='Adding…';}
if(status)status.textContent='';
try{
var route=(window.routes&&window.routes.cartAddUrl)||'/cart/add'; var url=route.endsWith('/') ? route.slice(0,-1)+'.js' : route+'.js';
var fd=new FormData(form);
var response=await fetch(url,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
var data=await response.json();
if(!response.ok) throw new Error(data.description||data.message||'Could not add this item.');
if(status)status.textContent='Added to cart.';
if(cartLink)cartLink.hidden=false;
if(add)add.textContent='Added to cart';
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));
}catch(error){
if(status)status.textContent=error.message||'Unable to add to cart.';
if(add)add.textContent='Add to cart';
}finally{
submitting=false;
if(add&&variant){
var selected=variant.options[variant.selectedIndex];
add.disabled=!selected||selected.dataset.available!=='true';
}
}
});
}
}
document.addEventListener('click',function(event){
var opener=event.target.closest('[data-dds-global-qv-open]');
if(!opener||!opener.closest('.product-item'))return;
event.preventDefault();event.stopPropagation();
if(open&&!submitting)close();
openCard(opener);
});
closer.addEventListener('click',close);
dialog.addEventListener('click',function(event){if(event.target===dialog)close();});
document.addEventListener('keydown',function(event){
if(!open)return;
if(event.key==='Escape'){event.preventDefault();close();return;}
if(event.key!=='Tab')return;
var els=Array.from(panel.querySelectorAll('button:not(:disabled),a[href],select:not(:disabled),input:not(:disabled)')).filter(function(el){return !el.hidden&&el.getClientRects().length;});
if(!els.length){event.preventDefault();closer.focus();return;}
var first=els[0],last=els[els.length-1];
if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
document.addEventListener('shopify:section:load',boot);
})();